import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

export const ServiceCard = ({ service, index = 0 }) => (
  <article className="group card overflow-hidden hover-lift reveal" style={{ animationDelay: `${index * 90}ms` }} data-testid={`service-card-${service.slug}`}>
    <Link to={service.path} className="block">
      <div className="relative h-60 overflow-hidden">
        <img
          src={service.image}
          alt={service.alt}
          width="1200"
          height="800"
          loading="lazy"
          decoding="async"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" aria-hidden="true" />
        <span className="absolute top-3 right-3 inline-flex items-center gap-1 rounded-full bg-gold px-2.5 py-1 text-[10px] font-bold text-night uppercase tracking-wider">
          <Sparkles size={12} aria-hidden="true" /> Lavenza
        </span>
        <div className="absolute bottom-4 left-4 right-4">
          <h3 className="text-xl md:text-2xl font-bold text-white drop-shadow leading-tight">{service.name}</h3>
          <p className="text-xs text-white/90 mt-1">{service.subtitle}</p>
        </div>
      </div>
      <div className="p-5">
        <p className="text-sm text-muted leading-relaxed mb-4">{service.short}</p>
        <div className="flex items-center justify-between">
          <span className="text-xs font-semibold text-emerald">Fiyat & süre: WhatsApp</span>
          <span className="inline-flex items-center gap-1 text-sm font-semibold text-gold group-hover:gap-2 transition-all">
            İncele <ArrowRight size={16} aria-hidden="true" />
          </span>
        </div>
      </div>
    </Link>
  </article>
);
